import authHeader from "./auth-header";
import { api, endpointUrl } from "./api";
import { redirectToLogin } from "./annoucement-sheet";

export type TwoFactorStatus = {
  two_factor_enabled: boolean;
  two_factor_pending: boolean;
};

export type TwoFactorEnableResponse = {
  /** Base32 secret, shown for manual entry when the QR cannot be scanned. */
  secret: string;
  /** otpauth:// URI — rendered as a QR code in the browser. */
  otpauth_url: string;
  message?: string;
};

export type TwoFactorMessageResponse = {
  status?: boolean;
  message?: string;
};

export const twoFactorApi = api.injectEndpoints({
  endpoints: (build) => ({
    getTwoFactorStatus: build.query<TwoFactorStatus, void>({
      query: () => ({
        url: `${endpointUrl}2fa/status`,
        headers: authHeader(),
      }),
      transformErrorResponse: (err) => {
        if (err?.status === 401) {
          redirectToLogin();
        }
      },
      providesTags: [{ type: "TwoFactorStatus", id: "STATUS" }],
    }),

    // Generates a pending secret. 2FA is not active until confirm succeeds.
    enableTwoFactor: build.mutation<TwoFactorEnableResponse, { password: string }>({
      query: (body) => ({
        url: `${endpointUrl}2fa/enable`,
        headers: authHeader(),
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "TwoFactorStatus", id: "STATUS" }],
    }),

    confirmTwoFactor: build.mutation<TwoFactorMessageResponse, { code: string }>({
      query: (body) => ({
        url: `${endpointUrl}2fa/confirm`,
        headers: authHeader(),
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "TwoFactorStatus", id: "STATUS" }],
    }),

    disableTwoFactor: build.mutation<TwoFactorMessageResponse, { password: string }>({
      query: (body) => ({
        url: `${endpointUrl}2fa/disable`,
        headers: authHeader(),
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "TwoFactorStatus", id: "STATUS" }],
    }),
  }),
});

export const {
  useGetTwoFactorStatusQuery,
  useEnableTwoFactorMutation,
  useConfirmTwoFactorMutation,
  useDisableTwoFactorMutation,
} = twoFactorApi;
